import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, interval, map, of, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';
import { GurdServiceService } from "src/app/Service/gurd-service.service";


declare let $: any;

@Component({

  selector: 'app-accumulative-dashboard',

  templateUrl: './accumulative-dashboard.component.html',

  styleUrls: ['./accumulative-dashboard.component.css'],

  animations: [
    trigger('fadeAnimation', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate('300ms ease-in', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('100ms ease-out', style({ opacity: 0 }))
      ])
    ])
  ]

})

export class AccumulativeDashboardComponent implements OnInit {

  filteredItems = [];

  list_Schools: any = [];

  searchText = '';

  iMobileDomain: string = '-1';

  ctxChart: any;

  ctxChart3: any;

  ctxChart2: any;

  ctxChart4: any;

  ctxChart5: any;

  ctxChart6: any;

  ctxChart7: any;

  schoolMap: any;

  journalMap: any;

  source: any;

  source2: any;

  vector: any;

  vector2: any;

  layers: any = [];

  layers2: any = [];

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  clusterModal: any;

  CHART_COLORS: any = {
    red: 'rgb(255, 99, 132)',
    orange: 'rgb(255, 159, 64)',
    yellow: 'rgb(255, 205, 86)',
    green: 'rgb(75, 192, 192)',
    blue: 'rgb(54, 162, 235)',
    purple: 'rgb(153, 102, 255)',
    grey: 'rgb(201, 203, 207)',
  };

  CHART_COLORS3: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  options!: Observable<any>;

  options3!: Observable<any>;

  constructor(

    private router: Router,

    private Notification: NotificationService,

    private FormBuilder: FormBuilder,

    private mapService: MapService,

    private gurdService: GurdServiceService


  ) {

    // Chart.register(...registerables);

    Chart.register(zoomPlugin);

  }

  ngOnInit(): void {

    this.getSchool();

    this.getCharts(this.iMobileDomain);



  }

  async getSchool() {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`School_User_List`, model)).data.toString());

    this.list_Schools = res;

  }

  async getCharts(iMobileDomain: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iMobileDomain: iMobileDomain,

      tiJournalType: 0

    }


    this.ticket_ChartBase(model);

    this.mobile_ChartBaseSchool(model);

    this.mobileDomainCluster(model);

    this.Students_ChartBaseSchool(model);

    this.report_GPSType(model);

    this.report_YearConstruction(model);

    this.report_RedDriving(model);

    this.report_MostSerious(model);

    this.report_GeoJournal(model);

    this.loadTree1('Tree_MobilesStatistics');

    this.loadTree4('Tree_MobilesAverageLife');


  }

  async ticket_ChartBase(model: any) {

    let res = JSON.parse(((await axios.post(`School_Tiket_ChartBaseSchool`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart1') as any;

    if (this.ctxChart) this.ctxChart.destroy();

    this.ctxChart = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });



  }

  async mobile_ChartBaseSchool(model: any) {

    let res = JSON.parse(((await axios.post(`School_Mobile_ChartBaseSchool`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart3') as any;

    if (this.ctxChart3) this.ctxChart3.destroy();

    this.ctxChart3 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async Students_ChartBaseSchool(model: any) {

    let res = JSON.parse(((await axios.post(`School_Students_ChartBaseSchool`, model)).data.toString()));

    let object = res;

    let label: any[] = [];

    let dataChart: any[] = [];

    object.forEach((element: any) => {

      label.push(element.X);

      dataChart.push(element.Y);

    });

    const ctx = document.getElementById('myChart2') as any;

    if (this.ctxChart2) this.ctxChart2.destroy();

    this.ctxChart2 = new Chart(ctx, {

      type: 'bar',

      data: {

        labels: label,

        datasets: [

          {
            label: '',

            data: dataChart,

            backgroundColor: Object.values(this.CHART_COLORS),


          },

        ],

      },

      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }
          }
        }
      },
    });


  }

  async mobileDomainCluster(model: any) {

    let res = JSON.parse(((await axios.post(`School_MobileDomainCluster`, model)).data.toString()));

    setTimeout(() => {

      if (this.schoolMap) this.schoolMap.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}) }), this.vector)
      }
      this.schoolMap = new Map({

        target: "map1",

        view: new View({

          zoom: 4,

          center: olProj.fromLonLat([51.3833554, 35.6770113])

        }),

        layers: this.layers

      });

      this.clustersLayer(res, model);

    }, 500);



  }

  async clustersLayer(data: any, model: []) {

    setTimeout(() => {

      this.schoolMap.on('click', (e: any) => {

        if (e.dragging) return

        var el = this.mapService.mapPointerMove(

          this.schoolMap.getEventPixel(e.originalEvent),

          this.schoolMap
        );

        this.Notification.showInfo(`نام مدرسه : ${el.featureLayer.feature.values_.features[0].values_.data.strComment}`, '')

        $("#link").click(() => {

          var tooltip = $('#map_tooltip');

          tooltip.tooltip('hide');

        });

      });

      this.schoolMap.getView().on('propertychange', function (e: any) {

        var tooltip = $('#map_tooltip');

        tooltip.tooltip('hide');

      });

    }, 200);



    var clusterSource = new Cluster({

      distance: 40,

      source: new Vector()

    }) as any;


    let addFeatures = (nb: any) => {

      var ext = this.schoolMap.getView().calculateExtent(this.schoolMap.getSize());

      var features = [];

      for (var i = 0; i < data.length; ++i) {

        features[i] = new Feature({

          type: 'removable',

          geometry: new Point(this.mapService.transformCoordinates2([

            data[i].dLongitude,

            data[i].dLatitude])

          ),

          id_: data[i].strUnitId,

          data: { strComment: data[i].strComment, },

        });

        features[i].set("id", i);
      }
      clusterSource.getSource().clear();

      clusterSource.getSource().addFeatures(features);


    }

    // Style for the clusters
    var styleCache = {} as any;
    function getStyle(feature: any, resolution: any) {
      var size = feature.get("features").length;
      var style = styleCache[size];
      if (!style) {
        var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
        var radius = Math.max(8, Math.min(size * 0.75, 20));
        var dash = (2 * Math.PI * radius) / 6;
        var dashs = [0, dash, dash, dash, dash, dash, dash];
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: "rgba(" + color + ",0.5)",
              width: 15,
              lineDash: dashs,
              lineCap: "butt"
            }),
            fill: new Fill({
              color: "rgba(" + color + ",1)"
            })
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: "#fff"
            })
          })
        });
      }
      return style;
    }

    // Animated cluster layer
    var clusterLayer = new AnimatedCluster({
      //name: "Cluster",
      source: clusterSource,
      animationDuration: 700,
      // Cluster style
      style: getStyle
    });
    this.schoolMap.addLayer(clusterLayer);
    // add 2000 features
    addFeatures(2000);

    var style1 = new Style({
      image: new Circle({
        radius: 5,
        stroke: new Stroke({
          color: "rgba(128,0,0,0.8)",
          width: 2
        }),
        fill: new Fill({
          color: "rgba(128,0,0,0.8)"
        })
      }),
      // Draw a link beetween points (or not)
      stroke: new Stroke({
        color: "#fff",
        width: 1
      })
    });
    // Select interaction to spread cluster out and select features
    var selectCluster = new SelectCluster({
      // Point radius: to calculate distance between the features
      pointRadius: 7,
      animate: true,
      // Feature style when it springs apart
      featureStyle: function () {
        return [style1];
      },
      // selectCluster: false,	// disable cluster selection
      // Style to draw cluster when selected
      style: function (f, res) {
        var cluster = f.get("features");
        if (cluster.length > 1) {
          return getStyle(f, res);
        } else {
          return [
            new Style({
              image: new Circle({
                stroke: new Stroke({
                  color: "rgba(0,0,192,0.5)",
                  width: 2
                }),
                fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                radius: 5
              })
            })
          ];
        }
      }
    });
    this.schoolMap.addInteraction(selectCluster);


  }

  async report_GPSType(model: any) {

    const resp = await axios.post(`Report_GPSType`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.Notification.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      window.localStorage.clear();

      return this.router.navigate(['login']);

    }

    let obj10 = resParse;

    let label10: any = [];

    let datachart10: any = [];

    obj10.forEach((element: any) => {

      label10.push(element.X);

      datachart10.push(element.Y);

    });

    const ctx = document.getElementById('myChart4') as any;

    if (this.ctxChart4) this.ctxChart4.destroy();

    this.ctxChart4 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: label10,
        datasets: [
          {
            data: datachart10,
            backgroundColor: Object.values(this.CHART_COLORS3),
            borderWidth: 1,
          },
        ],
      },
      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                //size: 25
                family: "vazir",
                size: 12
              }
            }

          }
        }
      },

    });

  }

  async report_YearConstruction(model: any) {

    const resp = await axios.post(`report_YearConstruction`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.Notification.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      window.localStorage.clear();

      return this.router.navigate(['login']);

    }

    let obj10 = resParse;

    let label10: any = [];

    let datachart10: any = [];

    obj10.forEach((element: any) => {

      label10.push(element.X);

      datachart10.push(element.Y);

    });

    const ctx = document.getElementById('myChart5') as any;

    if (this.ctxChart5) this.ctxChart5.destroy();

    this.ctxChart5 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: label10,
        datasets: [
          {
            data: datachart10,
            backgroundColor: Object.values(this.CHART_COLORS3),
            borderWidth: 1,
          },
        ],
      },
      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }

          }
        }
      },

    });

  }

  async report_RedDriving(model: any) {

    const resp = await axios.post(`Report_RedDriving`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.Notification.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      window.localStorage.clear();

      return this.router.navigate(['login']);

    }

    let obj10 = resParse;

    let label10: any = [];

    let datachart10: any = [];

    obj10.forEach((element: any) => {

      label10.push(element.X);

      datachart10.push(element.Y);

    });

    const ctx = document.getElementById('myChart6') as any;

    if (this.ctxChart6) this.ctxChart6.destroy();

    this.ctxChart6 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: label10,
        datasets: [
          {
            data: datachart10,
            backgroundColor: Object.values(this.CHART_COLORS3),
            borderWidth: 1,
          },
        ],
      },
      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "vazir",
                size: 12
              }
            }

          }
        }
      },

    });

  }

  async report_MostSerious(model: any) {

    const resp = await axios.post(`report_MostSerious`, model);

    let resParse = JSON.parse(resp.data);

    if (resParse.iResult == 0) return this.Notification.showError(resParse.strError);

    if (resParse.ISSessionExpired == true) {

      this.Notification.showError('لطفا وارد سیستم شوید');

      window.localStorage.clear();

      return this.router.navigate(['login']);

    }

    let obj10 = resParse;

    let label10: any = [];

    let datachart10: any = [];

    obj10.forEach((element: any) => {

      label10.push(element.X);

      datachart10.push(element.Y);

    });

    const ctx = document.getElementById('myChart7') as any;

    if (this.ctxChart7) this.ctxChart7.destroy();

    this.ctxChart7 = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: label10,
        datasets: [
          {
            data: datachart10,
            backgroundColor: Object.values(this.CHART_COLORS3),
            borderWidth: 1,
          },
        ],
      },
      options: {
                responsive: true,
        interaction: {
          mode: 'nearest',
          intersect: false
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
            }
          },
          legend: {
            position: 'center',
          },
          title: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: 'black',
              font: {
                family: "bYekan",
                size: 12
              }
            }

          }
        }
      },

    });

  }

  async report_GeoJournal(model: any) {

      this.source2 = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source2,

      });

      if (this.bOfflineMap) {

        this.layers2.push(

          new TileLayer({

            source: new XYZ({

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );
      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {
          this.layers2.push(
            new TileLayer({
              visible: false,
              preload: Infinity,
              source: new BingMaps({
                key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',

                imagerySet: styles[i],
              }),

            }),
          );
        }

        this.layers2.push(new TileLayer({ source: new OSM({}) }), this.vector2)
      }

    this.journalMap = new Map({

      target: "test2",

      view: new View({

        zoom: 4,

        center: olProj.fromLonLat([51.3833554, 35.6770113])

      }),

      layers: this.layers2

    });

    this.journalType(model);

  }

  loadTree1 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    const resp = await axios.post(`${api}`, model);
    this.options = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('totalVehicles') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  loadTree4 = async (api: any) => {
    var model = {
      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),
      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!)
    };
    const resp = await axios.post(`${api}`, model);
    this.options3 = of(resp.data)
      .pipe(
        map((data: any) => {
          let res = JSON.parse(data.toString());
          let not = 0;
          res.children.forEach((element: any) => {
            not += element.children.length
          });

          if (not > 50) {
            let can = document.getElementById('vehicleLife') as HTMLElement;
            can.style.height = '700px'
          }


          res.children.forEach(function (datum: any, index: number) {
            index % 1 === 0 && (datum.collapsed = true);
          });
          return {
            tooltip: {
              trigger: 'item',
              triggerOn: 'mousemove',
              responsive: true,
              textStyle: {
                color: '#000',
                fontFamily: 'vazir',
                fontSize: 12
              },
              formatter: function (params: any) {
                return `تعداد ${new Number(params.data.value).toLocaleString('fa-ir')} زیر مجموعه`
              }
            },
            series: [
              {
                type: 'tree',
                data: [res],
                top: '1%',
                left: '10%',
                responsive: true,
                bottom: '5%',
                right: '20%',
                symbolSize: 10,
                label: {
                  position: 'left',
                  fontFamily: 'vazir',
                  verticalAlign: 'middle',
                  align: 'right',
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#000',
                },
                leaves: {
                  label: {
                    position: 'right',
                    verticalAlign: 'middle',
                    align: 'left',
                    color: '#000'
                  },
                },
                expandAndCollapse: true,
                animationDuration: 550,
                animationDurationUpdate: 750,
              },
            ],
          };
        }),
      );
  }

  journalType = async (model: any) => {

    const res = await axios.post(`Report_GeoJournal`, model);

    this.clustersLayer2(JSON.parse(res.data));
  }

  clustersLayer2(data: any) {
    setTimeout(() => {
      this.journalMap.on('click', (e: any) => {
        if (e.dragging) {
          //...
          return;
        }

        var el = this.mapService.mapPointerMove(
          this.journalMap.getEventPixel(e.originalEvent),
          this.journalMap
        );
        this.showData(el);
        $("#link").click(() => {
          var tooltip = $('#map_tooltip');
          tooltip.tooltip('hide');

        });
      });
      this.journalMap.getView().on('propertychange', function (e: any) {
        var tooltip = $('#map_tooltip');
        tooltip.tooltip('hide');
      });
    }, 200);
    // Cluster Source
    this.mapService.removeLayerByName("Cluster", this.journalMap);
    var clusterSource = new Cluster({
      distance: 40,
      source: new Vector()
    }) as any;
    setTimeout(() => {
      this.journalMap.getView().animate({
        zoom: this.journalMap.getView().getZoom() - 0.001,
        duration: 250
      })
      // Addfeatures to the cluster
      let addFeatures = (nb: any) => {
        var ext = this.journalMap.getView().calculateExtent(this.journalMap.getSize());
        var features = [];

        for (var i = 0; i < data.length; ++i) {
          features[i] = new Feature({
            type: 'removable',
            geometry: new Point(this.mapService.transformCoordinates2([
              data[i].fLon,
              data[i].fLat])

            ),
            id_: data[i].strUnitId,
            data: {
              Id: data[i].strUnitId,
              strFullName: data[i].strFullName,
              strDate: data[i].strDate,
              strMobile: data[i].strMobile,
              strTime: data[i].strTime,
              strVehicleNo: data[i].strVehicleNo,
              strMobileType_strComment: data[i].strMobileType_strComment,
              strJournalType_strComment: data[i].strJournalType_strComment,
              tiMaxSpeed: data[i].tiMaxSpeed,
              strComment: data[i].strComment,



              // html: `${data[i].strFullName}`,
            },
          });
          features[i].set("id", i);
        }
        clusterSource.getSource().clear();
        clusterSource.getSource().addFeatures(features);


      }

      // Style for the clusters
      var styleCache = {} as any;
      function getStyle(feature: any, resolution: any) {
        var size = feature.get("features").length;
        var style = styleCache[size];
        if (!style) {
          var color = size > 25 ? "192,0,0" : size > 8 ? "255,128,0" : "0,128,0";
          var radius = Math.max(8, Math.min(size * 0.75, 20));
          var dash = (2 * Math.PI * radius) / 6;
          var dashs = [0, dash, dash, dash, dash, dash, dash];
          style = styleCache[size] = new Style({
            image: new Circle({
              radius: radius,
              stroke: new Stroke({
                color: "rgba(" + color + ",0.5)",
                width: 15,
                lineDash: dashs,
                lineCap: "butt"
              }),
              fill: new Fill({
                color: "rgba(" + color + ",1)"
              })
            }),
            text: new Text({
              text: size.toString(),
              fill: new Fill({
                color: "#fff"
              })
            })
          });
        }
        return style;
      }

      // Animated cluster layer
      var clusterLayer = new AnimatedCluster({
        name: "Cluster",
        source: clusterSource,
        animationDuration: 700,
        // Cluster style
        style: getStyle
      } as any);
      this.journalMap.addLayer(clusterLayer);
      // add 2000 features
      addFeatures(2000);

      var style1 = new Style({
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(128,0,0,0.8)",
            width: 2
          }),
          fill: new Fill({
            color: "rgba(128,0,0,0.8)"
          })
        }),
        // Draw a link beetween points (or not)
        stroke: new Stroke({
          color: "#fff",
          width: 1
        })
      });
      // Select interaction to spread cluster out and select features
      var selectCluster = new SelectCluster({
        // Point radius: to calculate distance between the features
        pointRadius: 7,
        animate: true,
        // Feature style when it springs apart
        featureStyle: function () {
          return [style1];
        },
        // selectCluster: false,	// disable cluster selection
        // Style to draw cluster when selected
        style: function (f, res) {
          var cluster = f.get("features");
          if (cluster.length > 1) {
            return getStyle(f, res);
          } else {
            return [
              new Style({
                image: new Circle({
                  stroke: new Stroke({
                    color: "rgba(0,0,192,0.5)",
                    width: 2
                  }),
                  fill: new Fill({ color: "rgba(0,0,192,0.3)" }),
                  radius: 5
                })
              })
            ];
          }
        }
      });
      this.journalMap.addInteraction(selectCluster);
    }, 50);



  }

  showData(item: any) {
    var tooltip = $('#map_tooltip');
    tooltip.tooltip({
      html: true,
      animation: true,
      trigger: 'manual',
      placement: 'top',
    });
    tooltip.css({
      left: item.pixel[0] + 'px',
      top: item.pixel[1] - 14 + 'px',
      zindex: 1000,
    });
    if (item.featureLayer) {
      if (item.featureLayer.feature) {
        if (item.featureLayer.feature.values_.features.length == 1) {
          if (item.featureLayer.feature.values_.features[0].values_.data.strFullName) {
            $('#carCluster').modal('show');
            this.clusterModal = item.featureLayer.feature.values_.features[0].values_.data;

          }
        }

      }
    } else {
      tooltip.tooltip('hide');
    }
  }

  onSchool_change(item: any) {

    this.searchText = item.strComment;

    this.filteredItems = []

    this.iMobileDomain = item.iMobileDomain;

    this.getCharts(item.iMobileDomain);


  }

  filterItems() {

    if (this.searchText == '') this.filteredItems = []

    else this.filteredItems = this.list_Schools.filter((item: any) => item.strComment.includes(this.searchText));
  }

  goBack() {

    this.router.navigateByUrl('')

  }

}
